import { render, staticRenderFns } from "./OnlineMagazineDetail.vue?vue&type=template&id=51b6f774&"
import script from "./OnlineMagazineDetail.vue?vue&type=script&lang=js&"
export * from "./OnlineMagazineDetail.vue?vue&type=script&lang=js&"
import style0 from "./OnlineMagazineDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports